import { render, staticRenderFns } from "./BusinessMemberInvites.vue?vue&type=template&id=3ad5eaa4"
import script from "./BusinessMemberInvites.vue?vue&type=script&lang=js"
export * from "./BusinessMemberInvites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports